export default "__VITE_ASSET__CVvqMtmK__"